import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLegStregthsL } from '../../../../utils';
import { LegInfo } from './LegInfo/LegInfo';
import { LevelZeroWrap } from './LevelZero.styles';
import { UserProfile } from './UserProfile';

export const LevelZero = ({ teamMember, teamMemberInfo }) => {
  const { t } = useTranslation('myTeam');
  const [leftLegStrenght, rightLegStrength] = getLegStregthsL(teamMember);

  return (
    <div>
      <LevelZeroWrap>
        <LegInfo
          legName={
            <>
              {t('left_team')} {leftLegStrenght}
            </>
          }
          legInfo={teamMemberInfo?.leftLegInfo}
        />
        <UserProfile teamMember={teamMember} teamMemberInfo={teamMemberInfo} />
        <LegInfo
          legName={
            <>
              {t('right_team')} {rightLegStrength}
            </>
          }
          legInfo={teamMemberInfo?.rightLegInfo}
        />
      </LevelZeroWrap>
    </div>
  );
};
